angular.module('impactx.productlabel', []);